import { Base64 } from 'js-base64';
import Cookies from 'js-cookie';
import jwt_decode from "jwt-decode";
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedAuth = ({ children }: any) => {
    const isAuthenticated = () => {
        const tokenBase64 = Cookies.get("token")
        if (tokenBase64) {
            const token = Base64.decode(tokenBase64);
            try {
                const tokenData: any = jwt_decode(token);
                const expirationTime = tokenData.exp;
                const currentTime = Math.floor(Date.now() / 1000);
                return currentTime < expirationTime;
            } catch (error) {
                console.error('Error parsing token:', error);
                return false;
            }
        } else {
            return false;
        }
    }

    const location = useLocation();

    const allowedPaths = ['/auth', '/register', '/forget-password', '/activation'];
    const adminPathsRegex = /^\/(auth|register|forget-password|activation)/;

    return isAuthenticated() === true ?
        <Navigate
            to={
                allowedPaths.includes(location.pathname) || adminPathsRegex.test(location.pathname)
                    ? '/admin'
                    : location.pathname
            }
            replace
            state={{ path: location.pathname }}
        />
        : (
            <Outlet />
        );
};

export default ProtectedAuth;

